import React, { useEffect, useRef } from 'react';

// TODO: Rename to "HeaderBannerNotification" or "HeaderNotifiation"
const Notification = ({ notification, setIsDialogVisible }) => {
    const headerRef = useRef(null);

    useEffect(() => {
        const headerElement = headerRef.current;

        if (headerElement) {
            const resizeObserver = new ResizeObserver(() => {
                const headerHeight = headerElement.offsetHeight;
                document.body.style.setProperty('--notification_height', `${headerHeight}px`);
            });

            resizeObserver.observe(headerElement);

            return () => {
                resizeObserver.unobserve(headerElement);
            };
        }
    }, []);

    return (
        <header ref={headerRef} id="dashboard-notification-header" className="notification is-primary has-text-centered p-2 m-0">
            <div className="dashboard-notification">
                <strong>{notification.strong}</strong> {notification.text} ‎
                <a
                    href={notification?.link || '#'}
                    onClick={(e) => {
                        if (notification?.has_dialog) {
                            e.preventDefault();
                            setIsDialogVisible(true);
                        }
                    }}
                >
                    ‎ {notification.link_text}
                </a>
            </div>
        </header>
    );
};

const notificationHandler = (user, selectedCompany, setNotification) => {
    if (!user || !selectedCompany || !setNotification) return;

    const europeanCountries = [
        'France', 'Germany', 'Spain', 'Italy', 'Belgium', 'Netherlands', 'Luxembourg',
        'Ireland', 'Portugal', 'Austria', 'Greece', 'Finland', 'Sweden', 'Denmark',
        'Poland', 'Czech Republic', 'Slovakia', 'Hungary', 'Romania', 'Bulgaria',
        'Croatia', 'Slovenia', 'Estonia', 'Latvia', 'Lithuania', 'Cyprus', 'Malta',
        'Norway', 'Switzerland', 'Iceland', 'Liechtenstein'
    ];

    if (!user.email_verified_at) return setNotification({
        strong: `Votre email n'a toujours pas été vérifié!`,
        text: 'Pour vérifier votre email, veuillez',
        link_text: 'cliquer ici!',
        link: "",
        has_dialog: true,
    });

    if (!selectedCompany?.siren_number && !selectedCompany?.is_verified) return setNotification({
        strong: ``,
        text: 'Pour effectuer des achats (abonnement ou crédits), veuillez nous fournir votre numéro de SIREN.',
        link_text: 'Cliquez ici.',
        link: "/dashboard/company",
        has_dialog: false,
    });

};

export { notificationHandler };
export default Notification;